import { useMutation } from "@tanstack/react-query";
import { http } from "../../utils";

async function cancelOrderPayment(productOrderId) {
  const data = await http(`/smartro-pay/cancel`, {
    method: "POST",
    data: {
      productOrderId,
    },
  });

  if (!data) {
    throw new Error("PAYMENT_CANCEL_FAILED");
  }

  return data;
}

export function useCancelOrderPayment() {
  return useMutation(cancelOrderPayment);
}
